import { NavLink } from 'react-router-dom';
import { IconConnection } from '@ui/src';
import TransactionItemRow from './transaction-item-row';
import TransactionItemBlock from './transaction-item-block';
import formatBalance from '../../hoc/helpers/format-balance';
import { TransactionDescription } from '../../hoc/cards/types';
import { TransactionItemTypes } from './types';

import cn from './card.module.css';

const TransactionItem = ({ transaction }: TransactionItemTypes) => (
  <>
    <TransactionItemBlock>
      <>
        <TransactionItemRow
          title="BC:"
          value={transaction?.bc?.toUpperCase()}
        />
        <TransactionItemRow
          title="Currency:"
          value={transaction?.currency.toUpperCase()}
        />
        <TransactionItemRow
          title="Amount BC:"
          value={formatBalance(transaction?.amountBc as string)}
        />
        <TransactionItemRow
          title="Amount:"
          value={formatBalance(transaction?.amount as string)}
        />
      </>
    </TransactionItemBlock>
    <TransactionItemBlock>
      <>
        <TransactionItemRow
          title="Merchant name:"
          value={transaction?.merchantName}
        />
        <TransactionItemRow
          title="Terminal ID:"
          value={transaction?.terminalId}
        />
      </>
    </TransactionItemBlock>
    <TransactionItemBlock>
      <TransactionItemRow
        title="Order details:"
        value={transaction?.orderDetails}
      />
    </TransactionItemBlock>
    {(transaction?.description === TransactionDescription.CHARGEBACK ||
      transaction?.description === TransactionDescription.REFUND) && (
      <NavLink
        to={`?orderDetails=${transaction.orderDetails}`}
        className={cn.relatedTransactionsLink}
      >
        <IconConnection />
        Related transactions
      </NavLink>
    )}
  </>
);

export default TransactionItem;
